import type { FaireProductEntity } from "../../entity_types/product";

export const p_d8mz68m87x: FaireProductEntity = {
  token: "p_d8mz68m87x",
  type: "product",
  name: "Gemstone Crystal Heart Paw - Carved Heart Paw",
  brandToken: "b_de8f5way8k",
  brandName: "Rock Paradise",
  imageUrl:
    "https://cdn.faire.com/fastly/8880da92f4e9393b65a7d5861fd56736cd69a4936ce95437d098cceb9b8596a9.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6441ee63d7cc4c82986284be3362ac1cf9e915900a217e6dff5c52f9d425f84b.jpeg",
    "https://cdn.faire.com/fastly/835c04681f17053c56d63af970fcb6ab1b9e1a49553a3d98382cf6c5148dc789.jpeg",
    "https://cdn.faire.com/fastly/52852485de27ee0f48d0f4f44e89aeebb9d9588b6330ab95ec1844b8ecfa9d70.jpeg",
    "https://cdn.faire.com/fastly/9046ff7fa7d3bd09fd734f30a7d5b7367a6bdd3ec79668bf7b63c4a5412feacf.jpeg",
    "https://cdn.faire.com/fastly/5958652a5169479d21aaa054ddf9d6ac5ec576e7064e043e34b3732798c8630a.jpeg",
    "https://cdn.faire.com/fastly/2cd2eb2653c96c961a4eb62282e58add273a71f5ddc6801e48cac577e9de8961.jpeg",
    "https://cdn.faire.com/fastly/d04717b93a6f0567fcca8fe151e746ea5a9554f1c0a2ee57ea1551a894beb011.jpeg",
  ],
  priceDollars: 11.09,
  description:
    'Listing is for 1 (ONE) Gemstone Crystal Heart Paw - Carved Heart Paw \n\nThis unique Gemstone Crystal Heart Paw is hand carved from natural crystal and polished to a smooth, glossy finish. Each piece is crafted from a genuine gemstone, showcasing beautiful natural colors, patterns, and textures formed by nature.\n\nProduct Details:\n\n * Content: 1 (One) Gemstone Crystal Heart Paw - Carved Heart Paw - You select the Gemstone \n * Measures Approx.: 1.5" x 1.5" \n * You select the Gemstone! Available in:\n\n * Rose Quartz - Love Stone \n * Crystal Quartz - Master Stone \n * Black Obsidian - Protection Stone\n\n * Sodalite - Stone of Truth\n\n * Opalite - Calming Stone \n * Fluorite - Healing Stone \n * White Howlite - Calming Stone \n * Green Aventurine - Opportunity Stone \n * Gold Sheen Obsidian - Protection Stone \n * Silver Sheen Obsidian - Protection Stone \n * Stock Photo: Each stone will vary slightly in size and characteristics due to natural formations. \nDisclaimer:\n\nPlease consult a healthcare professional for any medical advice. The information provided is not intended to diagnose, treat, cure, or prevent any disease or condition.\n',
  tags: [],
  msrpDollars: 22.17,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:49:19.061Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
